import request from "./../utils/request";

export function createComment(siteId, commentData) {
    return request({
        url: "/comments/create",
        method: "post",
        headers: {
            "site-id": siteId,
        },
        data: commentData,
    });
}


export function getComment(siteId, type, id) {
    return request({
        url: "/comments",
        method: "get",
        headers: {
            "site-id": siteId,
        },
        params: {
            type: type,
            id: id,
        },
    });
}

export function deleteComment(siteId, id) {
    return request({
        url: "/comments/delete",
        method: "delete",
        headers: {
            "site-id": siteId,
        },
        params: {
            id: id,
        },
    });
}


export function updateComment(siteId, id, newMessage) {
    return request({
        url: `/comments/${id}`,
        method: "put",
        headers: {
            "site-id": siteId,
        },
        data: {
            newMessage: newMessage,
        },
    });
}
